import { useCallback } from 'react';
import { useAllieStorage } from "./useAllieStorage";
import { isMobile, isSmartTV } from '../helpers';

const GUEST_UID = 0;
const LOGIN_PATH = '/login';
const WELCOME_PATH = '/welcome';
const EXCLUDED_PAGES_FOR_RESTORE = [LOGIN_PATH, WELCOME_PATH];

export const DEPRECATED_PAGES = ['/machines', '/work-orders', '/incidents'];
export const MOBILE_DEFAULT_PAGE = '/factory-gpt';
export const DEFAULT_PAGE = '/efficiency';
export const TV_DEFAULT_PAGE = '/efficiency/shift/dashboard';

export const useAllieRouting = () => {
  const {
    getLastVisitedPage,
    getLoggedUser,
    setLastVisitedPage,
    getPermissions,
  } = useAllieStorage();

  const getDefaultPage = useCallback(() => {
    const permissions = getPermissions();
    return isMobile ? MOBILE_DEFAULT_PAGE : DEFAULT_PAGE;
  }, [getPermissions]);

  const loggedUser = getLoggedUser();

  const saveLastVisitedPage: (lastPage: string) => void = useCallback((lastPage) => {
    if (!EXCLUDED_PAGES_FOR_RESTORE.includes(lastPage) && Object.keys(loggedUser).length) {
      const lastPages = getLastVisitedPage();
      if (loggedUser && loggedUser.id !== GUEST_UID) {
        setLastVisitedPage({
          [GUEST_UID]: lastPages[GUEST_UID.toString()] || getDefaultPage(),
          [loggedUser.id]: lastPage,
        });
      } else {
        setLastVisitedPage({ ...lastPages, [GUEST_UID]: lastPage });
      }
    }
  }, [getLastVisitedPage, loggedUser, setLastVisitedPage, getDefaultPage]);
 
  const resolvePage = (page: string) => (
    (!page || DEPRECATED_PAGES.some(dp => page.includes(dp))) ? getDefaultPage() : page
  );

  const restoreLastVisitedPage = (userId: number) => {
    if (isSmartTV) {
      document.location.href = TV_DEFAULT_PAGE;
    } else {
      const lastPages = getLastVisitedPage();
      document.location.href = resolvePage(lastPages[userId.toString()]);
    }
  };

  const goToLogin = () => {
    document.location.href = `${LOGIN_PATH}`;
  };

  return { saveLastVisitedPage, restoreLastVisitedPage, goToLogin, getDefaultPage, resolvePage }
};
